<div class="body">
    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Tipo de Cuenta </label> </div>

        <div class="col-lg-5">
            <mat-form-field appearance="outline" class="mat-input">
                <mat-select name="tipoCuenta" #tipoCuenta="ngModel" [disabled]="afiliado.deshabilitado"
                    [(ngModel)]="afiliado.tipoCuentaCodigo">
                    <mat-option *ngFor="let estado of this.afiliado.tipoCuentas" [value]="estado.id">
                        {{estado.descripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </div>
    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Entidad Bancaria </label> </div>

        <div class="col-lg-5">
            <mat-form-field appearance="outline" class="mat-input">

                <mat-select name="banco" #banco="ngModel" [disabled]="afiliado.deshabilitado"
                    [(ngModel)]="afiliado.bancoCodigo">
                    <mat-option *ngFor="let estado of this.afiliado.bancos" [value]="estado.id">
                        {{estado.descripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </div>
    <br />

    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Número Cuenta </label> </div>

        <div class="col-lg-5">
            <input id="numeroCuenta" name="numeroCuenta" class="form-control" [disabled]="afiliado.deshabilitado"
                [(ngModel)]="afiliado.numeroCuenta" type="text"  (input)="soloNumeros($event)" [maxlength]="18">
        </div>
    </div>
    <div class="col-lg-3"> </div>

</div>

<!--/form-->